import { NativeModules, Platform } from 'react-native';

export async function fazerRequisicaoNativaAsync(url: string) {
  if (Platform.OS === 'android' && NativeModules.Requisicao != null) {
    return await NativeModules.Requisicao.fazerRequisicaoAsync(url);
  }
}
